import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

const Bar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 0;
`;

const MainActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: var(--spacer-m);
  flex-grow: 1;
`;

const RightActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const Action = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 15px;
  transition: color 0.3s ease-in-out;

  &.mod-float-right {
    flex-direct: ;
  }

  &.mod-small {
    gap: 10px;
  }

  &:hover {
    color: var(--theme-color-primary);

    * {
      fill: white;
    }

    &.mod-blue {
      span:first-of-type {
        background: var(--theme-palette-blue);
      }
    }

    span:first-of-type {
      background: var(--theme-color-primary);
    }
  }
`;

const ActionIcon = styled.span`
  align-items: center;
  border: solid 2px var(--theme-color-primary);
  border-radius: 50%;
  display: flex;
  padding: 10px;
  transition: background 0.3s ease-in-out;

  &.mod-small {
    padding: 7px;
  }

  &.mod-active {
    background: var(--theme-color-primary);
  }

  &.mod-blue {
    border: solid 2px var(--theme-palette-blue);
  }

  &.mod-active.mod-blue {
    background: var(--theme-palette-blue);
  }
`;

const ActionLabel = styled.span`
  font-family: var(--theme-typography-primary-font);
  font-size: 20px;
  font-weight: 700;
  text-decoration: underline;

  .mod-small & {
    font-size: 16px;
  }
`;

export type ActionBarProps = {
  actions?: {
    icon?: any;
    label?: string;
    onClick?: () => void;
    active?: boolean;
    hoverable?: boolean;
    small?: boolean;
    floatRight?: boolean;
    altColors?: boolean;
  }[];
};

export const ActionBar = ({ actions }: ActionBarProps) => {
  const mainActions = actions
    ?.map((action) => {
      if (action.floatRight) {
        return null;
      }

      return action;
    })
    .filter(Boolean);

  const rightActions = actions
    ?.map((action) => {
      if (action.floatRight) {
        return action;
      }

      return null;
    })
    .filter(Boolean);

  return (
    <Bar>
      <MainActions>
        {mainActions?.map((action, index) => (
          <Action
            key={index}
            className={classNames({
              'mod-hoverable': action.hoverable,
              'mod-small': action.small,
              'mod-float-right': action.floatRight,
            })}
            onClick={() => action.onClick()}
          >
            <ActionIcon className={action.active ? 'mod-active' : ''}>{action.icon}</ActionIcon>
            <ActionLabel>{action.label}</ActionLabel>
          </Action>
        ))}
      </MainActions>
      <RightActions>
        {rightActions?.map((action, index) => (
          <Action
            key={index}
            className={classNames({
              'mod-hoverable': action.hoverable,
              'mod-small': action.small,
              'mod-blue': action.altColors,
            })}
            onClick={() => action.onClick()}
          >
            <ActionIcon className={classNames({ 'mod-active': action.active, 'mod-blue': action.altColors })}>
              {action.icon}
            </ActionIcon>
            <ActionLabel>{action.label}</ActionLabel>
          </Action>
        ))}
      </RightActions>
    </Bar>
  );
};
